/**
 * Which blocky character a player gets. Its own module, free of three.js and MapLibre, so the hash
 * can be tested directly — the bug it carried was pure arithmetic and needed no GPU to find, but it
 * took a browser to notice.
 */

/** Kenney's CC0 "Blocky Characters", a–r, in public/models/characters. */
export const CHARACTERS = "abcdefghijklmnopqr".split("").map((c) => `character-${c}`);

/**
 * Stable per player id, and evenly spread.
 *
 * ⚠️ The `>>> 0` is needed AFTER the xor as well as before it. `^` evaluates its operands as SIGNED
 * int32, so it re-signs a hash that was just made unsigned; JS `%` keeps the sign of the dividend,
 * and `CHARACTERS[-13]` is `undefined`. That silently left 47.2% of all player ids with no model at
 * all — measured over 100k ids, not estimated.
 *
 * The failure is per-id and deterministic: an affected player never sees a character and an
 * unaffected one never sees the bug, which is why it was reported as "do you have the models for
 * players? I don't see any" (Cam, 2026-09-07) rather than as anything intermittent. Reproduced the
 * same day on a local instance — player id 1 grouped under the key `null`, `built: false`, 0
 * instances, while all 18 characters had loaded correctly.
 */
export function characterFor(id: number): string {
  let h = (id * 2654435761) >>> 0;
  h ^= h >>> 15;
  return CHARACTERS[(h >>> 0) % CHARACTERS.length];
}
